import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Flex, Form, Input, Switch } from 'antd';
import { editableTableLib, editableTableModel } from 'components/editable-table';

export const EditableCell: React.FC<editableTableLib.EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  children,
  required = true,
  inputType = 'string',
  inputStyle,
  ...restProps
}) => {
  const inputNodes: Record<editableTableLib.InputType, JSX.Element> = {
    string: <Input style={inputStyle} />,
    boolean: <Switch style={inputStyle} />,
    longString: <Input.TextArea autoSize={{ maxRows: 2 }} style={inputStyle} />,
  };
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required,
              message: `Заполните поле!`,
            },
          ]}
          valuePropName={inputType === 'boolean' ? 'checked' : undefined}
        >
          {inputNodes[inputType]}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export const renderEdit = ({
  editingKey,
  setEditingKey,
  record,
  form,
  mutationReq,
}: editableTableLib.RenderEditProps): React.ReactNode => {
  if (editingKey !== record.key)
    return (
      <Flex justify={'center'}>
        <Button
          icon={<EditOutlined />}
          onClick={() => editableTableModel.onEditClick({ record, setEditingKey, form })}
        />
      </Flex>
    );
  return (
    <Flex justify={'center'} gap={10}>
      <Button
        icon={<CheckOutlined />}
        onClick={() => editableTableModel.onEditSave({ record, setEditingKey, form, mutationReq })}
      />
      <Button
        danger
        icon={<CloseOutlined />}
        onClick={() => editableTableModel.onEditCancel({ setEditingKey })}
      />
    </Flex>
  );
};
